import {
  SET_APP_SETTINGS,
  SET_DARK_MODE,
  SET_EXPORT_SETTINGS,
  SET_USER_SETTINGS,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').ExportSettings} ExportSettings
 * @typedef {import('../index').UserSettings} UserSettings
 * @typedef {import('../index').AppSettings} AppSettings
 */

/**
 * @typedef {ReturnType<typeof setExportSettings> | ReturnType<typeof setUserSettings> | ReturnType<typeof setAppSettings> | ReturnType<typeof setDarkMode>} SettingsActions
 */

/**
 * @param {ExportSettings} exportSettings
 * @return {{ type: 'SET_EXPORT_SETTINGS', exportSettings: ExportSettings }}
 */
export const setExportSettings = (exportSettings) => ({
  type: SET_EXPORT_SETTINGS,
  exportSettings,
})

/**
 * @param {UserSettings} userSettings
 * @return {{ type: 'SET_USER_SETTINGS', userSettings: UserSettings }}
 */
export const setUserSettings = (userSettings) => ({
  type: SET_USER_SETTINGS,
  userSettings,
})

/**
 * @param {AppSettings} appSettings
 * @return {{ type: 'SET_APP_SETTINGS', appSettings: AppSettings }}
 */
export const setAppSettings = (appSettings) => ({
  type: SET_APP_SETTINGS,
  appSettings,
})

/**
 * WARNING: only use this action if we were told by some special
 * source (in the case of Desktop, the main process).  If you want to
 * change the dark mode setting, it's best to change the settings
 * store and have the listener update the value instead.
 *
 * @param {'dark' | 'light' | 'system'} value
 * @return {{ type: 'SET_DARK_MODE', value: 'dark' | 'light' | 'system' }}
 */
export const setDarkMode = (value) => {
  return {
    type: SET_DARK_MODE,
    value,
  }
}
